import mod from "-!./index.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./index.js?vue&type=script&lang=js&external"